import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "setting-unmanaged-business-page" }
const _hoisted_2 = { class: "setting-unmanaged-business-page__header" }
const _hoisted_3 = {
  key: 0,
  class: "setting-unmanaged-business-page__container"
}
const _hoisted_4 = { class: "setting-unmanaged-business-page__top-area" }
const _hoisted_5 = { class: "setting-unmanaged-business-page__title-block" }
const _hoisted_6 = { class: "setting-unmanaged-business-page__title" }
const _hoisted_7 = { class: "setting-unmanaged-business-page__subtitle" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "setting-unmanaged-business-page__table-wrapper" }
const _hoisted_10 = { class: "setting-unmanaged-business-page__table-head-row" }
const _hoisted_11 = {
  key: 0,
  class: "setting-unmanaged-business-page__empty-row"
}
const _hoisted_12 = { class: "setting-unmanaged-business-page__table-row" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "setting-unmanaged-business-page__name-cell" }
const _hoisted_15 = { class: "setting-unmanaged-business-page__name-text" }
const _hoisted_16 = { class: "setting-unmanaged-business-page__date-text" }
const _hoisted_17 = { class: "setting-unmanaged-business-page__condition-cell" }
const _hoisted_18 = { class: "setting-unmanaged-business-page__count-chip" }
const _hoisted_19 = { class: "setting-unmanaged-business-page__condition-summary" }
const _hoisted_20 = { class: "setting-unmanaged-business-page__text-cell" }
const _hoisted_21 = { class: "setting-unmanaged-business-page__text-cell" }
const _hoisted_22 = { class: "setting-unmanaged-business-page__text-cell" }
const _hoisted_23 = { class: "setting-unmanaged-business-page__action-cell" }
const _hoisted_24 = ["disabled", "onClick"]
const _hoisted_25 = ["disabled", "onClick"]
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = {
  key: 0,
  class: "setting-unmanaged-business-page__detail-row"
}
const _hoisted_28 = { class: "setting-unmanaged-business-page__detail-block" }
const _hoisted_29 = { class: "setting-unmanaged-business-page__detail-title" }
const _hoisted_30 = { class: "setting-unmanaged-business-page__detail-block" }
const _hoisted_31 = { class: "setting-unmanaged-business-page__detail-title" }
const _hoisted_32 = { class: "setting-unmanaged-business-page__detail-text" }
const _hoisted_33 = { class: "setting-unmanaged-business-page__detail-text" }
const _hoisted_34 = { class: "setting-unmanaged-business-page__detail-text" }
const _hoisted_35 = {
  key: 1,
  class: "setting-unmanaged-business-page__detail-text"
}
const _hoisted_36 = {
  key: 1,
  class: "setting-unmanaged-business-page__row-border"
}
const _hoisted_37 = { class: "setting-unmanaged-business-page__note" }
const _hoisted_38 = {
  key: 1,
  class: "setting-unmanaged-business-page__container"
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "setting-unmanaged-business-page__editor-header" }
const _hoisted_41 = { class: "setting-unmanaged-business-page__title" }
const _hoisted_42 = { class: "setting-unmanaged-business-page__subtitle" }
const _hoisted_43 = { class: "setting-unmanaged-business-page__form-card" }
const _hoisted_44 = { class: "setting-unmanaged-business-page__input-label" }
const _hoisted_45 = ["value", "placeholder", "disabled"]
const _hoisted_46 = { class: "setting-unmanaged-business-page__form-card" }
const _hoisted_47 = { class: "setting-unmanaged-business-page__section-header" }
const _hoisted_48 = { class: "setting-unmanaged-business-page__section-title" }
const _hoisted_49 = { class: "setting-unmanaged-business-page__section-sub-title" }
const _hoisted_50 = { class: "setting-unmanaged-business-page__conditions-card" }
const _hoisted_51 = { class: "setting-unmanaged-business-page__condition-number" }
const _hoisted_52 = { class: "setting-unmanaged-business-page__condition-fixed-field" }
const _hoisted_53 = { class: "setting-unmanaged-business-page__input-label" }
const _hoisted_54 = { class: "setting-unmanaged-business-page__condition-fixed-value" }
const _hoisted_55 = { class: "setting-unmanaged-business-page__condition-counterpart" }
const _hoisted_56 = { class: "setting-unmanaged-business-page__new-option-card" }
const _hoisted_57 = { class: "setting-unmanaged-business-page__section-sub-title" }
const _hoisted_58 = { class: "setting-unmanaged-business-page__new-option-grid" }
const _hoisted_59 = {
  key: 0,
  class: "setting-unmanaged-business-page__register-item"
}
const _hoisted_60 = { class: "setting-unmanaged-business-page__input-label" }
const _hoisted_61 = ["placeholder", "disabled"]
const _hoisted_62 = { class: "setting-unmanaged-business-page__register-item" }
const _hoisted_63 = { class: "setting-unmanaged-business-page__input-label" }
const _hoisted_64 = ["placeholder", "disabled"]
const _hoisted_65 = { class: "setting-unmanaged-business-page__register-item" }
const _hoisted_66 = { class: "setting-unmanaged-business-page__input-label" }
const _hoisted_67 = ["placeholder", "disabled"]
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { class: "setting-unmanaged-business-page__form-card" }
const _hoisted_70 = { class: "setting-unmanaged-business-page__section-title" }
const _hoisted_71 = { class: "setting-unmanaged-business-page__section-sub-title" }
const _hoisted_72 = { class: "setting-unmanaged-business-page__register-grid" }
const _hoisted_73 = { class: "setting-unmanaged-business-page__register-item" }
const _hoisted_74 = { class: "setting-unmanaged-business-page__input-label" }
const _hoisted_75 = ["value", "placeholder", "disabled"]
const _hoisted_76 = { class: "setting-unmanaged-business-page__register-item" }
const _hoisted_77 = { class: "setting-unmanaged-business-page__input-label" }
const _hoisted_78 = ["value", "placeholder", "disabled"]
const _hoisted_79 = { class: "setting-unmanaged-business-page__register-item" }
const _hoisted_80 = { class: "setting-unmanaged-business-page__input-label" }
const _hoisted_81 = ["value", "placeholder", "disabled"]
const _hoisted_82 = { class: "setting-unmanaged-business-page__section-header setting-unmanaged-business-page__optional-header" }
const _hoisted_83 = { class: "setting-unmanaged-business-page__section-sub-title" }
const _hoisted_84 = ["disabled"]
const _hoisted_85 = {
  key: 0,
  class: "setting-unmanaged-business-page__optional-empty"
}
const _hoisted_86 = { class: "setting-unmanaged-business-page__register-item" }
const _hoisted_87 = { class: "setting-unmanaged-business-page__input-label" }
const _hoisted_88 = ["disabled", "onClick"]
const _hoisted_89 = { class: "setting-unmanaged-business-page__footer-actions" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = ["disabled"]

import { diContainer } from '@/coreContainer/container';
import {
  cloneUnmanagedBusinessAutoRegisterCondition,
  cloneUnmanagedBusinessAutoRegisterSettingItem,
  createDefaultUnmanagedBusinessAutoRegisterCondition,
  createDefaultUnmanagedBusinessAutoRegisterOptionalRegisterItem,
  createDefaultUnmanagedBusinessAutoRegisterSettingItem,
  createUnmanagedBusinessAutoRegisterSettingId,
  getConditionSearchTypesByFieldType,
  normalizeUnmanagedBusinessAutoRegisterCondition,
  UnmanagedBusinessAutoRegisterCondition,
  UnmanagedBusinessAutoRegisterConditionFieldType,
  UnmanagedBusinessAutoRegisterField,
  UnmanagedBusinessAutoRegisterSettingConditionItem,
  UnmanagedBusinessAutoRegisterSettingItem,
} from '@/coreDomainsModule/constants/unmanagedBusinessAutoRegister';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import SuggestInput from '@/corePagesModule/components/SuggestInput.vue';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import SelectInput from '@/corePagesModule/components/SelectInput.vue';
import ErrorMessage from '@/corePagesModule/components/ErrorMessage.vue';
import { i18n } from '@/i18n';
import SettingsPageTitle from '@/settingsModule/components/SettingsPageTitle.vue';
import {
  numericOptionalRegisterFields,
  optionalRegisterFields,
  requiredConditionFieldTypes,
} from '@/settingsModule/constants/unmanagedBusinessAutoRegister';
import { useUnmanagedBusinessAutoRegisterLabels } from '@/settingsModule/composables/useUnmanagedBusinessAutoRegisterLabels';
import { useUnmanagedBusinessAutoRegisterFormValidation } from '@/settingsModule/composables/useUnmanagedBusinessAutoRegisterFormValidation';
import { useUnmanagedBusinessAutoRegisterConditionOptions } from '@/settingsModule/composables/useUnmanagedBusinessAutoRegisterConditionOptions';
import { useUnmanagedBusinessAutoRegisterOptionalItemOptions } from '@/settingsModule/composables/useUnmanagedBusinessAutoRegisterOptionalItemOptions';
import { SettingPageMode, useSettingUnmanagedBusinessStore } from '@/settingsModule/pages/settingContent/useSettingUnmanagedBusinessStore';
import { onBeforeMount, reactive, ref } from 'vue';

interface NewConditionOptionInput {
  targetFieldType: UnmanagedBusinessAutoRegisterConditionFieldType;
  code: string;
  name: string;
  value: string;
}

/**
 * サーバー取得値反映時の画面状態オプション
 */
interface ApplyServerSettingOptions {
  previousOpenedSettingIds?: string[];
  openFirstIfNone?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingUnmanagedBusinessPage',
  setup(__props) {

const t = i18n.t;

/**
 * 条件候補追加フォームの入力値
 */
const {
  getConditionFieldTypeLabel,
  getFieldLabel,
  getRegisterUnitLabel,
  getConditionFieldTypeOptions,
  getOptionalFieldOptions,
  getRegisterUnitOptions,
  convertLabelToConditionFieldType,
  convertLabelToConditionSearchType,
  convertLabelToTargetField,
  convertLabelToRegisterUnit,
  getSearchTypeLabelsByConditionItem,
  getConditionSearchTypeSelectLabel,
} = useUnmanagedBusinessAutoRegisterLabels();

const settingUnmanagedBusinessStore = useSettingUnmanagedBusinessStore();
const {
  state,
  resetState,
  setInitialized,
  setIsSaving,
  setMode,
  setEditingSettingId,
  setCondition,
  setUpdateAt,
  setOpenedSettingIds,
  toggleOpenedSetting,
  setFormSetting,
  setFormConditions,
  setFormSettingName,
  setFormLeadTime,
  setFormStdInventoryIndicesMin,
  setFormStdInventoryIndicesMax,
  setFormConditionSearchType,
  setFormConditionTargetValue,
  addFormOptionalItem,
  removeFormOptionalItem,
  setFormOptionalItemTargetField,
  setFormOptionalItemTargetValue,
  setFormLeadTimeUnit,
  setFormStdInventoryIndicesUnit,
} = settingUnmanagedBusinessStore;

/**
 * 検証対象のフォーム設定を取得する
 */
const getCurrentFormSetting = (): UnmanagedBusinessAutoRegisterSettingItem => {
  return state.formSetting;
};

const numericInputValues = reactive({
  leadTime: '',
  stdInventoryIndicesMin: '',
  stdInventoryIndicesMax: '',
});

/**
 * 登録内容の数値入力値を返す
 */
const getNumericInputValues = (): typeof numericInputValues => {
  return numericInputValues;
};

/**
 * 登録内容の数値入力欄を設定値で初期化する
 */
const syncNumericInputValues = (): void => {
  numericInputValues.leadTime = String(state.formSetting.registerContent.leadTime);
  numericInputValues.stdInventoryIndicesMin = String(state.formSetting.registerContent.stdInventoryIndicesMin);
  numericInputValues.stdInventoryIndicesMax = String(state.formSetting.registerContent.stdInventoryIndicesMax);
};

/**
 * 数値入力文字列を数値へ変換する
 * @param rawValue - 入力文字列
 * @param fallbackValue - 変換失敗時に使用する値
 */
const convertInputToNumber = (rawValue: string, fallbackValue: number): number => {
  const trimmedValue = rawValue.trim();
  if (trimmedValue === '') {
    return fallbackValue;
  }
  const parsedValue = Number(trimmedValue);
  if (Number.isFinite(parsedValue)) {
    return parsedValue;
  }
  return fallbackValue;
};

/**
 * 設定名入力イベントを処理する
 * @param event - inputイベント
 */
const onSettingNameInput = (event: Event): void => {
  const value = (event.target as HTMLInputElement).value;
  setFormSettingName(value);
  updateSettingNameValidation(value);
};

/**
 * リードタイム入力イベントを処理する
 * @param event - inputイベント
 */
const onLeadTimeInput = (event: Event): void => {
  const value = (event.target as HTMLInputElement).value;
  numericInputValues.leadTime = value;
  setFormLeadTime(convertInputToNumber(value, state.formSetting.registerContent.leadTime));
  updateLeadTimeValidation(value);
};

/**
 * 標準在庫指数min入力イベントを処理する
 * @param event - inputイベント
 */
const onStdInventoryIndicesMinInput = (event: Event): void => {
  const value = (event.target as HTMLInputElement).value;
  numericInputValues.stdInventoryIndicesMin = value;
  setFormStdInventoryIndicesMin(convertInputToNumber(value, state.formSetting.registerContent.stdInventoryIndicesMin));
  updateStdInventoryIndicesMinValidation(value);
};

/**
 * 標準在庫指数max入力イベントを処理する
 * @param event - inputイベント
 */
const onStdInventoryIndicesMaxInput = (event: Event): void => {
  const value = (event.target as HTMLInputElement).value;
  numericInputValues.stdInventoryIndicesMax = value;
  setFormStdInventoryIndicesMax(convertInputToNumber(value, state.formSetting.registerContent.stdInventoryIndicesMax));
  updateStdInventoryIndicesMaxValidation(value);
};

/**
 * 任意項目値の更新イベントを処理する
 * @param optionalItemIndex - 任意項目index
 * @param targetValue - 更新後の値
 */
const onOptionalItemTargetValueUpdate = (optionalItemIndex: number, targetValue: string): void => {
  setFormOptionalItemTargetValue(optionalItemIndex, targetValue);
  revalidateOptionalItemsIfNeeded();
};

/**
 * 任意項目で既に使用中の対象フィールド一覧を返す
 */
const getUsedOptionalFields = (): UnmanagedBusinessAutoRegisterField[] => {
  return state.formSetting.registerContent.optionalItems.map((optionalItem) => optionalItem.targetField);
};

/**
 * 任意項目indexごとに選択可能な対象フィールド一覧を返す
 * @param optionalItemIndex - 任意項目index
 */
const getSelectableOptionalFields = (optionalItemIndex: number): UnmanagedBusinessAutoRegisterField[] => {
  const usedFieldsByOthers = new Set(
    state.formSetting.registerContent.optionalItems
      .filter((_, index) => index !== optionalItemIndex)
      .map((optionalItem) => optionalItem.targetField)
  );
  const currentField = state.formSetting.registerContent.optionalItems[optionalItemIndex]?.targetField;

  return optionalRegisterFields.filter((optionalField) => {
    return optionalField === currentField || !usedFieldsByOthers.has(optionalField);
  });
};

/**
 * 任意項目選択肢ラベル一覧を返す
 * @param optionalItemIndex - 任意項目index
 */
const getOptionalFieldSelectOptions = (optionalItemIndex: number): string[] => {
  return getOptionalFieldOptions(getSelectableOptionalFields(optionalItemIndex));
};

/**
 * 任意項目を追加可能か判定する
 */
const canAddOptionalItem = (): boolean => {
  const usedFields = new Set(getUsedOptionalFields());
  return optionalRegisterFields.some((optionalField) => !usedFields.has(optionalField));
};

const {
  fieldState,
  syncFormValidationState,
  revalidateConditionValuesIfNeeded,
  revalidateOptionalItemsIfNeeded,
  updateSettingNameValidation,
  updateLeadTimeValidation,
  updateStdInventoryIndicesMinValidation,
  updateStdInventoryIndicesMaxValidation,
  validateForm,
  resetValidationState,
} = useUnmanagedBusinessAutoRegisterFormValidation({
  getFormSetting: getCurrentFormSetting,
  getNumericInputValues,
  requiredConditionFieldTypes,
  numericOptionalRegisterFields,
  getFieldLabel,
});

const {
  resetConditionValueOptions,
  appendConditionOptionValue,
  appendConditionOptionPair,
  loadConditionValueOptionsFromApi,
  appendConditionValueOptionsFromSettings,
  getConditionValueOptions,
  getConditionCounterpartText,
  getConditionCodeNamePair,
  resolveConditionCodeNamePair,
  syncConditionCounterpartOption,
} = useUnmanagedBusinessAutoRegisterConditionOptions({
  requiredConditionFieldTypes,
});

/**
 * 現在の設定一覧を返す
 */
const getCurrentSettings = (): UnmanagedBusinessAutoRegisterSettingItem[] => {
  return state.condition.settings;
};

const { loadOptionalItemOptionSources, getOptionalItemOptions } = useUnmanagedBusinessAutoRegisterOptionalItemOptions({
  getSettings: getCurrentSettings,
  getConditionValueOptions,
});

const newConditionOptionInput = reactive<NewConditionOptionInput>({
  targetFieldType: requiredConditionFieldTypes[0],
  code: '',
  name: '',
  value: '',
});

/**
 * 指定された条件項目の入力初期値を作成する
 * @param targetFieldType - 条件項目
 */
const createDefaultConditionItemByFieldType = (
  targetFieldType: UnmanagedBusinessAutoRegisterConditionFieldType
): UnmanagedBusinessAutoRegisterSettingConditionItem => ({
  targetFieldType,
  searchType: getConditionSearchTypesByFieldType(targetFieldType)[0],
  targetValue: '',
});

/**
 * 編集フォーム用に必須6KEY分の条件を正規化する
 * @param conditions - 元の条件一覧
 */
const normalizeConditionsForForm = (
  conditions: UnmanagedBusinessAutoRegisterSettingConditionItem[]
): UnmanagedBusinessAutoRegisterSettingConditionItem[] => {
  return requiredConditionFieldTypes.map((targetFieldType) => {
    const conditionItem = conditions.find((candidateConditionItem) => candidateConditionItem.targetFieldType === targetFieldType);
    if (conditionItem == null) {
      return createDefaultConditionItemByFieldType(targetFieldType);
    }

    const availableSearchTypes = getConditionSearchTypesByFieldType(targetFieldType);
    const normalizedSearchType = availableSearchTypes.includes(conditionItem.searchType)
      ? conditionItem.searchType
      : availableSearchTypes[0];
    return {
      targetFieldType,
      searchType: normalizedSearchType,
      targetValue: conditionItem.targetValue,
      targetName: conditionItem.targetName,
    };
  });
};

/**
 * 一覧行のアコーディオン開閉を判定する
 * @param settingId - 設定ID
 */
const isSettingOpened = (settingId: string): boolean => {
  return state.openedSettingIds.includes(settingId);
};

/**
 * 一覧行のアコーディオンを開閉する
 * @param settingId - 設定ID
 */
const toggleSetting = (settingId: string): void => {
  toggleOpenedSetting(settingId);
};

/**
 * UNIX時刻を画面表示用の日付文字列へ変換する
 * @param unixTime - UNIX時刻
 */
const formatDate = (unixTime: number): string => {
  const date = new Date(unixTime);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }
  return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
};

/**
 * 条件一覧表示用のコード/名称文字列を作成する
 * @param conditionItem - 条件
 */
const getConditionCodeNameDisplayText = (conditionItem: UnmanagedBusinessAutoRegisterSettingConditionItem): string => {
  const targetValue = conditionItem.targetValue.trim();
  if (targetValue === '') {
    return '-';
  }

  if (conditionItem.targetFieldType === 'package') {
    return targetValue;
  }

  const codeNamePair = getConditionCodeNamePair(conditionItem);
  if (codeNamePair != null) {
    return `${codeNamePair.code}（${t('名称')}：${codeNamePair.name}）`;
  }

  if (conditionItem.searchType === 'code') {
    return `${targetValue}（${t('名称')}：-）`;
  }
  return `-（${t('名称')}：${targetValue}）`;
};

/**
 * 条件一覧表示用の要約文字列を作成する
 * @param setting - 設定
 */
const getConditionSummary = (setting: UnmanagedBusinessAutoRegisterSettingItem): string => {
  const conditionSummaries = setting.conditions
    .map((conditionItem) => {
      const targetValue = conditionItem.targetValue.trim();
      if (targetValue === '') {
        return '';
      }
      return `${getConditionFieldTypeLabel(conditionItem.targetFieldType)}: ${getConditionCodeNameDisplayText(conditionItem)}`;
    })
    .filter((summary) => summary !== '');

  if (conditionSummaries.length === 0) {
    return t('条件未設定') as string;
  }

  return conditionSummaries.slice(0, 2).join(', ');
};

/**
 * 有効条件数を返す
 * @param setting - 設定
 */
const getEffectiveConditionCount = (setting: UnmanagedBusinessAutoRegisterSettingItem): number => {
  return setting.conditions.filter((conditionItem) => conditionItem.targetValue.trim() !== '').length;
};

/**
 * 条件詳細表示用の文字列を作成する
 * @param conditionItem - 条件
 */
const getConditionDetailText = (conditionItem: UnmanagedBusinessAutoRegisterSettingConditionItem): string => {
  const conditionFieldLabel = getConditionFieldTypeLabel(conditionItem.targetFieldType);
  const conditionDisplayValue = getConditionCodeNameDisplayText(conditionItem);
  if (conditionDisplayValue === '-') {
    return `${conditionFieldLabel}: -`;
  }

  return `${conditionFieldLabel}: ${conditionDisplayValue}`;
};

/**
 * 任意項目件数表示を返す
 * @param setting - 設定
 */
const getOptionalItemLabel = (setting: UnmanagedBusinessAutoRegisterSettingItem): string => {
  const validOptionalItemCount = setting.registerContent.optionalItems.filter(
    (optionalItem) => optionalItem.targetValue.trim() !== ''
  ).length;

  return validOptionalItemCount === 0 ? (t('なし') as string) : `${validOptionalItemCount}${t('件')}`;
};

/**
 * リードタイム表示文字列を作成する
 * @param setting - 設定
 */
const getLeadTimeLabel = (setting: UnmanagedBusinessAutoRegisterSettingItem): string => {
  return `${setting.registerContent.leadTime}${getRegisterUnitLabel(setting.registerContent.leadTimeUnit)}`;
};

/**
 * 在庫指数表示文字列を作成する
 * @param setting - 設定
 */
const getStdInventoryIndicesLabel = (setting: UnmanagedBusinessAutoRegisterSettingItem): string => {
  return `${setting.registerContent.stdInventoryIndicesMin} ～ ${setting.registerContent.stdInventoryIndicesMax}${getRegisterUnitLabel(
    setting.registerContent.stdInventoryIndicesUnit
  )}`;
};

/**
 * 反映後の設定一覧からアコーディオン開閉状態を解決する
 * @param settings - 反映後の設定一覧
 * @param previousOpenedSettingIds - 反映前の展開中設定ID一覧
 * @param openFirstIfNone - 展開対象がない場合に先頭を開くか
 */
const resolveOpenedSettingIds = (
  settings: UnmanagedBusinessAutoRegisterSettingItem[],
  previousOpenedSettingIds: string[] = [],
  openFirstIfNone = true
): string[] => {
  const existingSettingIds = new Set(settings.map((setting) => setting.settingId));
  const nextOpenedSettingIds = previousOpenedSettingIds.filter((openedSettingId) => existingSettingIds.has(openedSettingId));

  if (nextOpenedSettingIds.length > 0 || !openFirstIfNone) {
    return nextOpenedSettingIds;
  }

  if (settings.length === 0) {
    return [];
  }

  return [settings[0].settingId];
};

/**
 * サーバー取得値で画面状態を更新する
 * @param condition - 設定条件
 * @param updateAt - 更新時刻
 * @param options - 画面状態反映オプション
 */
const applyServerSetting = (
  condition: UnmanagedBusinessAutoRegisterCondition,
  updateAt: number | undefined,
  options: ApplyServerSettingOptions = {}
): void => {
  const { previousOpenedSettingIds = [], openFirstIfNone = true } = options;
  const normalizedCondition = normalizeUnmanagedBusinessAutoRegisterCondition(condition);
  normalizedCondition.settings = normalizedCondition.settings.map((setting) => ({
    ...cloneUnmanagedBusinessAutoRegisterSettingItem(setting),
    conditions: normalizeConditionsForForm(setting.conditions),
  }));
  normalizedCondition.enabled = normalizedCondition.settings.length > 0;
  appendConditionValueOptionsFromSettings(normalizedCondition.settings);
  normalizedCondition.settings.forEach((setting) => {
    setting.conditions.forEach((conditionItem) => {
      void syncConditionCounterpartOption(conditionItem);
    });
  });

  setCondition(normalizedCondition);
  setUpdateAt(updateAt);
  setOpenedSettingIds(resolveOpenedSettingIds(normalizedCondition.settings, previousOpenedSettingIds, openFirstIfNone));
};

/**
 * エラーモーダルを表示する
 * @param title - モーダルタイトル
 * @param description - モーダル本文
 */
const showErrorModal = async (title: string, description: string): Promise<void> => {
  await showInfoModal({
    modalTitle: title,
    modalDescription: description,
    backButtonLabel: t('OK'),
    isDisabledNextButton: true,
    enableOutsideClick: false,
    icon: 'error',
    colorStyle: 'error',
  });
};

/**
 * 設定をサーバーから取得する
 */
const loadSettingFromServer = async (): Promise<void> => {
  const result = await diContainer.getUnmanagedBusinessAutoRegisterSettingUseCase.Execute();

  if (result.status.type === 'success') {
    applyServerSetting(result.status.data.condition, result.status.data.updateAt, {
      previousOpenedSettingIds: state.openedSettingIds,
      openFirstIfNone: true,
    });
    return;
  }

  applyServerSetting(createDefaultUnmanagedBusinessAutoRegisterCondition(), undefined, {
    previousOpenedSettingIds: state.openedSettingIds,
    openFirstIfNone: true,
  });
  await showErrorModal(t('未管理取引の自動登録設定の取得に失敗しました'), t('通信環境を確認して再度お試しください。') as string);
};

/**
 * 編集フォームで使用する設定を初期化する
 * @param mode - 画面モード
 * @param setting - 編集対象の設定
 */
const openForm = (mode: Exclude<SettingPageMode, 'list'>, setting?: UnmanagedBusinessAutoRegisterSettingItem): void => {
  setMode(mode);
  resetValidationState();

  if (setting == null) {
    setEditingSettingId(undefined);
    const defaultFormSetting = createDefaultUnmanagedBusinessAutoRegisterSettingItem();
    setFormSetting(defaultFormSetting);
    setFormConditions(normalizeConditionsForForm([]));
    syncNumericInputValues();
    syncFormValidationState(false);
    return;
  }

  setEditingSettingId(setting.settingId);
  const editableFormSetting = cloneUnmanagedBusinessAutoRegisterSettingItem(setting);
  setFormSetting(editableFormSetting);
  setFormConditions(normalizeConditionsForForm(state.formSetting.conditions));
  syncNumericInputValues();
  syncFormValidationState(false);
  state.formSetting.conditions.forEach((conditionItem) => {
    void syncConditionCounterpartOption(conditionItem);
  });
};

/**
 * 一覧画面へ戻る
 */
const backToList = (): void => {
  setMode('list');
  setEditingSettingId(undefined);
  resetValidationState();
};

/**
 * 追加画面を開く
 */
const openCreateForm = (): void => {
  openForm('create');
};

/**
 * 編集画面を開く
 * @param setting - 編集対象
 */
const openEditForm = (setting: UnmanagedBusinessAutoRegisterSettingItem): void => {
  openForm('edit', setting);
};

/**
 * 検索方法を更新する
 * @param conditionIndex - 更新対象の条件index
 * @param selectedLabel - SelectInputで選択したラベル
 */
const updateConditionSearchType = (conditionIndex: number, selectedLabel: string): void | Promise<void> => {
  const conditionItem = state.formSetting.conditions[conditionIndex];
  const selectedSearchType = convertLabelToConditionSearchType(selectedLabel);
  const availableSearchTypes = getConditionSearchTypesByFieldType(conditionItem.targetFieldType);

  const normalizedSearchType = availableSearchTypes.includes(selectedSearchType) ? selectedSearchType : availableSearchTypes[0];
  setFormConditionSearchType(conditionIndex, normalizedSearchType);
  setFormConditionTargetValue(conditionIndex, '');
  revalidateConditionValuesIfNeeded();
  return syncConditionCounterpartOption(state.formSetting.conditions[conditionIndex]);
};

/**
 * 条件値を更新する
 * @param conditionIndex - 更新対象の条件index
 * @param selectedValue - 選択値
 */
const updateConditionValue = async (conditionIndex: number, selectedValue: string): Promise<void> => {
  const conditionItem = state.formSetting.conditions[conditionIndex];
  setFormConditionTargetValue(conditionIndex, selectedValue);
  appendConditionOptionValue(conditionItem.targetFieldType, conditionItem.searchType, selectedValue);
  revalidateConditionValuesIfNeeded();
  await syncConditionCounterpartOption(state.formSetting.conditions[conditionIndex]);
};

/**
 * 新規候補に条件項目を追加する
 */
const addNewConditionOption = async (): Promise<void> => {
  const conditionIndex = state.formSetting.conditions.findIndex(
    (conditionItem) => conditionItem.targetFieldType === newConditionOptionInput.targetFieldType
  );

  if (newConditionOptionInput.targetFieldType === 'package') {
    const normalizedValue = newConditionOptionInput.value.trim();
    if (normalizedValue === '') {
      await showErrorModal(t('入力内容を確認してください'), t('容量の値を入力してください') as string);
      return;
    }
    appendConditionOptionValue('package', 'value', normalizedValue);
    if (conditionIndex >= 0) {
      setFormConditionSearchType(conditionIndex, 'value');
      setFormConditionTargetValue(conditionIndex, normalizedValue);
      revalidateConditionValuesIfNeeded();
    }
    newConditionOptionInput.value = '';
    return;
  }

  const normalizedCode = newConditionOptionInput.code.trim();
  const normalizedName = newConditionOptionInput.name.trim();
  if (normalizedCode === '' || normalizedName === '') {
    await showErrorModal(t('入力内容を確認してください'), t('コードと名称の両方を入力してください') as string);
    return;
  }

  appendConditionOptionPair(newConditionOptionInput.targetFieldType, normalizedCode, normalizedName);
  if (conditionIndex >= 0) {
    setFormConditionSearchType(conditionIndex, 'code');
    setFormConditionTargetValue(conditionIndex, normalizedCode);
    revalidateConditionValuesIfNeeded();
  }
  newConditionOptionInput.code = '';
  newConditionOptionInput.name = '';
};

/**
 * 任意項目を追加する
 */
const addOptionalItem = (): void => {
  const usedFields = new Set(getUsedOptionalFields());
  const nextAvailableField = optionalRegisterFields.find((optionalField) => !usedFields.has(optionalField));
  if (nextAvailableField == null) {
    return;
  }

  const newOptionalItem = createDefaultUnmanagedBusinessAutoRegisterOptionalRegisterItem();
  newOptionalItem.targetField = nextAvailableField;
  addFormOptionalItem(newOptionalItem);
  revalidateOptionalItemsIfNeeded();
};

/**
 * 任意項目を削除する
 * @param optionalItemIndex - 削除対象index
 */
const removeOptionalItem = (optionalItemIndex: number): void => {
  removeFormOptionalItem(optionalItemIndex);
  revalidateOptionalItemsIfNeeded();
};

/**
 * 任意項目の対象フィールドを更新する
 * @param optionalItemIndex - 任意項目index
 * @param selectedLabel - SelectInputで選択したラベル
 */
const updateOptionalItemField = (optionalItemIndex: number, selectedLabel: string): void => {
  const selectedTargetField = convertLabelToTargetField(selectedLabel);
  const isSelectedByOtherOptionalItem = state.formSetting.registerContent.optionalItems.some((optionalItem, index) => {
    return index !== optionalItemIndex && optionalItem.targetField === selectedTargetField;
  });
  if (isSelectedByOtherOptionalItem) {
    return;
  }

  setFormOptionalItemTargetField(optionalItemIndex, selectedTargetField);
  revalidateOptionalItemsIfNeeded();
};

/**
 * 入力値を保存形式へ整形する
 */
const normalizeFormSetting = async (): Promise<{
  setting: UnmanagedBusinessAutoRegisterSettingItem;
  unresolvedConditionFieldLabels: string[];
}> => {
  const unresolvedConditionFieldLabelSet = new Set<string>();
  const normalizedConditions: UnmanagedBusinessAutoRegisterSettingConditionItem[] = [];

  for (const conditionItem of state.formSetting.conditions) {
    const normalizedTargetValue = conditionItem.targetValue.trim();
    if (normalizedTargetValue === '') {
      continue;
    }

    if (conditionItem.targetFieldType === 'package') {
      normalizedConditions.push({
        targetFieldType: conditionItem.targetFieldType,
        searchType: conditionItem.searchType,
        targetValue: normalizedTargetValue,
      });
      continue;
    }

    const normalizedConditionPair = await resolveConditionCodeNamePair({
      ...conditionItem,
      targetValue: normalizedTargetValue,
    });
    if (normalizedConditionPair == null) {
      unresolvedConditionFieldLabelSet.add(getConditionFieldTypeLabel(conditionItem.targetFieldType));
      continue;
    }

    normalizedConditions.push({
      targetFieldType: conditionItem.targetFieldType,
      searchType: 'code',
      targetValue: normalizedConditionPair.code,
      targetName: normalizedConditionPair.name,
    });
  }

  return {
    setting: {
      ...cloneUnmanagedBusinessAutoRegisterSettingItem(state.formSetting),
      settingName: state.formSetting.settingName.trim(),
      conditions: normalizedConditions,
      registerContent: {
        ...state.formSetting.registerContent,
        leadTime: Number(numericInputValues.leadTime),
        stdInventoryIndicesMin: Number(numericInputValues.stdInventoryIndicesMin),
        stdInventoryIndicesMax: Number(numericInputValues.stdInventoryIndicesMax),
        optionalItems: state.formSetting.registerContent.optionalItems
          .map((optionalItem) => ({
            targetField: optionalItem.targetField,
            targetValue: numericOptionalRegisterFields.has(optionalItem.targetField)
              ? String(Number(optionalItem.targetValue.trim()))
              : optionalItem.targetValue.trim(),
          }))
          .filter((optionalItem) => optionalItem.targetValue !== ''),
      },
    },
    unresolvedConditionFieldLabels: [...unresolvedConditionFieldLabelSet],
  };
};

/**
 * 設定一覧をサーバーへ保存する
 * @param settings - 保存対象の設定一覧
 */
const saveSettings = async (settings: UnmanagedBusinessAutoRegisterSettingItem[]): Promise<boolean> => {
  if (state.isSaving) {
    return false;
  }

  const previousOpenedSettingIds = [...state.openedSettingIds];

  setIsSaving(true);

  const normalizedSettings = settings.map((setting) => ({
    ...cloneUnmanagedBusinessAutoRegisterSettingItem(setting),
    settingName: setting.settingName.trim(),
  }));

  const saveCondition: UnmanagedBusinessAutoRegisterCondition = {
    ...cloneUnmanagedBusinessAutoRegisterCondition(state.condition),
    enabled: normalizedSettings.length > 0,
    settings: normalizedSettings,
  };

  const result = await diContainer.saveUnmanagedBusinessAutoRegisterSettingUseCase.Execute({
    condition: saveCondition,
    updateAt: state.updateAt,
  });

  setIsSaving(false);

  if (result.status.type === 'success') {
    applyServerSetting(result.status.data.condition, result.status.data.updateAt, {
      previousOpenedSettingIds,
      openFirstIfNone: false,
    });
    return true;
  }

  if (result.status.error.code === 'UPDATE_TIMING_CONFLICT') {
    await showErrorModal(
      t('未管理取引の自動登録設定の保存に失敗しました'),
      t('他のユーザーの更新と競合しました。最新の設定を再読み込みしたので、内容を確認して再度変更してください。') as string
    );
    await loadSettingFromServer();
    return false;
  }

  await showErrorModal(t('未管理取引の自動登録設定の保存に失敗しました'), t('通信環境を確認して再度お試しください。') as string);

  return false;
};

/**
 * 追加/編集フォームを保存する
 */
const saveFormSetting = async (): Promise<void> => {
  const validateError = validateForm();
  if (validateError != null) {
    await showErrorModal(t('入力内容を確認してください'), validateError);
    return;
  }

  const normalizedResult = await normalizeFormSetting();
  if (normalizedResult.unresolvedConditionFieldLabels.length > 0) {
    await showErrorModal(
      t('入力内容を確認してください'),
      `${t('以下の条件項目でコードを特定できませんでした') as string}：${normalizedResult.unresolvedConditionFieldLabels.join('、')}`
    );
    return;
  }

  const nextSettings =
    state.mode === 'edit'
      ? state.condition.settings.map((setting) => (setting.settingId === state.editingSettingId ? normalizedResult.setting : setting))
      : [...state.condition.settings, normalizedResult.setting];

  const saved = await saveSettings(nextSettings);
  if (saved) {
    backToList();
  }
};

/**
 * 設定を複製する
 * @param setting - 複製元設定
 */
const duplicateSetting = async (setting: UnmanagedBusinessAutoRegisterSettingItem): Promise<void> => {
  const copiedSetting = cloneUnmanagedBusinessAutoRegisterSettingItem(setting);
  copiedSetting.settingId = createUnmanagedBusinessAutoRegisterSettingId();
  copiedSetting.settingName =
    copiedSetting.settingName.trim() === '' ? (t('コピー設定') as string) : `${copiedSetting.settingName}${t('（コピー）')}`;
  copiedSetting.createdAt = Date.now();

  await saveSettings([...state.condition.settings, copiedSetting]);
};

/**
 * 設定を削除する
 * @param setting - 削除対象
 */
const deleteSetting = async (setting: UnmanagedBusinessAutoRegisterSettingItem): Promise<void> => {
  const displaySettingName = setting.settingName.trim() === '' ? (t('無題') as string) : setting.settingName;

  const confirmed = await showInfoModal({
    modalTitle: t('設定を削除しますか'),
    modalDescription: `${t('設定名') as string}：${displaySettingName}`,
    backButtonLabel: t('キャンセル'),
    nextButtonLabel: t('削除する'),
    enableOutsideClick: false,
    icon: 'error',
    colorStyle: 'error',
  });

  if (!confirmed) {
    return;
  }

  const nextSettings = state.condition.settings.filter((targetSetting) => targetSetting.settingId !== setting.settingId);
  await saveSettings(nextSettings);
};

/**
 * フォームで使用するSelectInput indexを返す
 * @param base - ベース値
 * @param offset - オフセット
 */
const getFormSelectInputIndex = (base: number, offset: number): number => {
  return base * 100 + offset;
};

onBeforeMount(async () => {
  resetState();
  resetConditionValueOptions();
  await Promise.all([loadOptionalItemOptionSources(), loadConditionValueOptionsFromApi()]);
  await loadSettingFromServer();
  setInitialized(true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(SettingsPageTitle, {
        label: _unref(t)('設定 > 未管理取引')
      }, null, 8, ["label"])
    ]),
    (_unref(state).mode === 'list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(t)('自動登録条件設定')), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('条件に応じた自動登録設定を管理します')) + " " + _toDisplayString(`（${_unref(t)('設定数')} ${_unref(state).condition.settings.length}）`), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "setting-unmanaged-business-page__primary-button",
              disabled: _unref(state).isSaving,
              onClick: openCreateForm
            }, _toDisplayString(_unref(t)('新規設定を追加')), 9, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[6] || (_cache[6] = _createElementVNode("p", null, null, -1)),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('設定名')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('条件')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('リードタイム')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('在庫指数')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('任意項目')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('操作')), 1)
            ]),
            (_unref(state).condition.settings.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)('設定がありません。新規設定を追加してください。')), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).condition.settings, (setting, settingIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: setting.settingId,
                class: "setting-unmanaged-business-page__table-body"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "setting-unmanaged-business-page__icon-button setting-unmanaged-business-page__expand-button",
                    onClick: ($event: any) => (toggleSetting(setting.settingId))
                  }, [
                    _createVNode(Mdi, {
                      icon: isSettingOpened(setting.settingId) ? 'expand_less' : 'expand_more',
                      "aria-label": "toggle"
                    }, null, 8, ["icon"])
                  ], 8, _hoisted_13),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(setting.settingName.trim() === '' ? _unref(t)('無題') : setting.settingName), 1),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(formatDate(setting.createdAt)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(`${getEffectiveConditionCount(setting)}${_unref(t)('件')}`), 1),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(getConditionSummary(setting)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(getLeadTimeLabel(setting)), 1),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(getStdInventoryIndicesLabel(setting)), 1),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(getOptionalItemLabel(setting)), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "setting-unmanaged-business-page__icon-button",
                      disabled: _unref(state).isSaving,
                      onClick: ($event: any) => (openEditForm(setting))
                    }, [
                      _createVNode(Mdi, {
                        icon: "edit",
                        "aria-label": _unref(t)('編集') as string
                      }, null, 8, ["aria-label"])
                    ], 8, _hoisted_24),
                    _createElementVNode("button", {
                      type: "button",
                      class: "setting-unmanaged-business-page__icon-button",
                      disabled: _unref(state).isSaving,
                      onClick: ($event: any) => (duplicateSetting(setting))
                    }, [
                      _createVNode(Mdi, {
                        icon: "content_copy",
                        "aria-label": _unref(t)('複製') as string
                      }, null, 8, ["aria-label"])
                    ], 8, _hoisted_25),
                    _createElementVNode("button", {
                      type: "button",
                      class: "setting-unmanaged-business-page__icon-button",
                      disabled: _unref(state).isSaving,
                      onClick: ($event: any) => (deleteSetting(setting))
                    }, [
                      _createVNode(Mdi, {
                        icon: "delete_outline",
                        "aria-label": _unref(t)('削除') as string
                      }, null, 8, ["aria-label"])
                    ], 8, _hoisted_26)
                  ])
                ]),
                (isSettingOpened(setting.settingId))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)('条件詳細')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setting.conditions, (conditionItem, conditionIndex) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: `${setting.settingId}-condition-${conditionIndex}`,
                            class: "setting-unmanaged-business-page__detail-text"
                          }, _toDisplayString(getConditionDetailText(conditionItem)), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(t)('登録項目詳細')), 1),
                        _createElementVNode("p", _hoisted_32, _toDisplayString(`${_unref(t)('リードタイム')}：${setting.registerContent.leadTime}${_unref(getRegisterUnitLabel)(setting.registerContent.leadTimeUnit)}`), 1),
                        _createElementVNode("p", _hoisted_33, _toDisplayString(`${_unref(t)('標準在庫指数')}：${setting.registerContent.stdInventoryIndicesMin} ～ ${
                    setting.registerContent.stdInventoryIndicesMax
                  }${_unref(getRegisterUnitLabel)(setting.registerContent.stdInventoryIndicesUnit)}`), 1),
                        (setting.registerContent.optionalItems.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(t)('任意項目')) + "：", 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setting.registerContent.optionalItems, (optionalItem, optionalItemIndex) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: `${setting.settingId}-optional-${optionalItemIndex}`,
                                  class: "setting-unmanaged-business-page__detail-text"
                                }, _toDisplayString(`${_unref(getFieldLabel)(optionalItem.targetField)}：${optionalItem.targetValue}`), 1))
                              }), 128))
                            ], 64))
                          : (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(`${_unref(t)('任意項目')}：${_unref(t)('なし')}`), 1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (settingIndex !== _unref(state).condition.settings.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(t)('1設定内はAND条件、設定同士はOR条件で判定される。')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("button", {
            type: "button",
            class: "setting-unmanaged-business-page__back-button",
            disabled: _unref(state).isSaving,
            onClick: backToList
          }, [
            _createVNode(Mdi, { icon: "arrow_back" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)('一覧に戻る')), 1)
          ], 8, _hoisted_39),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h2", _hoisted_41, _toDisplayString(_unref(state).mode === 'create' ? _unref(t)('新規設定を追加') : _unref(t)('設定を編集')), 1),
            _createElementVNode("p", _hoisted_42, _toDisplayString(_unref(state).mode === 'create' ? _unref(t)('新しい自動登録条件設定を作成します') : _unref(t)('自動登録条件設定を編集します')), 1)
          ]),
          _createElementVNode("section", _hoisted_43, [
            _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(t)('設定名')) + " *", 1),
            _createElementVNode("input", {
              value: _unref(state).formSetting.settingName,
              class: "setting-unmanaged-business-page__text-input",
              type: "text",
              placeholder: _unref(t)('例: 東京倉庫 - 製品A設定'),
              disabled: _unref(state).isSaving,
              onInput: onSettingNameInput
            }, null, 40, _hoisted_45),
            _createVNode(ErrorMessage, {
              "is-error": _unref(fieldState).settingName.isError.value,
              "error-message": _unref(fieldState).settingName.errorMessage.value
            }, null, 8, ["is-error", "error-message"])
          ]),
          _createElementVNode("section", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("p", _hoisted_48, _toDisplayString(_unref(t)('条件設定')), 1)
            ]),
            _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(t)('KEY6項目（入力した項目のみAND判定）')), 1),
            _createElementVNode("div", _hoisted_50, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).formSetting.conditions, (conditionItem, conditionIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `form-condition-${conditionIndex}`,
                  class: "setting-unmanaged-business-page__condition-row"
                }, [
                  _createElementVNode("div", _hoisted_51, _toDisplayString(conditionIndex + 1), 1),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, _toDisplayString(_unref(t)('条件項目')), 1),
                    _createElementVNode("p", _hoisted_54, _toDisplayString(_unref(getConditionFieldTypeLabel)(conditionItem.targetFieldType)), 1)
                  ]),
                  _createVNode(SelectInput, {
                    index: getFormSelectInputIndex(conditionIndex, 1),
                    "model-value": _unref(getConditionSearchTypeSelectLabel)(conditionItem),
                    options: _unref(getSearchTypeLabelsByConditionItem)(conditionItem),
                    placeholder: _unref(t)('選択してください'),
                    label: _unref(t)('検索方法'),
                    "show-deselect-option": false,
                    disabled: _unref(state).isSaving,
                    "onUpdate:modelValue": (selectedLabel) => updateConditionSearchType(conditionIndex, selectedLabel)
                  }, null, 8, ["index", "model-value", "options", "placeholder", "label", "disabled", "onUpdate:modelValue"]),
                  _createVNode(SelectInput, {
                    index: getFormSelectInputIndex(conditionIndex, 2),
                    "model-value": conditionItem.targetValue,
                    options: _unref(getConditionValueOptions)(conditionItem),
                    placeholder: _unref(t)('選択してください'),
                    label: _unref(t)('値'),
                    "show-deselect-option": false,
                    disabled: _unref(state).isSaving,
                    "onUpdate:modelValue": (selectedValue) => updateConditionValue(conditionIndex, selectedValue)
                  }, null, 8, ["index", "model-value", "options", "placeholder", "label", "disabled", "onUpdate:modelValue"]),
                  _createElementVNode("p", _hoisted_55, _toDisplayString(_unref(getConditionCounterpartText)(conditionItem)), 1)
                ]))
              }), 128))
            ]),
            _createVNode(ErrorMessage, {
              "is-error": _unref(fieldState).conditionValues.isError.value,
              "error-message": _unref(fieldState).conditionValues.errorMessage.value
            }, null, 8, ["is-error", "error-message"]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("p", _hoisted_57, _toDisplayString(_unref(t)('候補にない値を追加')), 1),
              _createElementVNode("div", _hoisted_58, [
                _createVNode(SelectInput, {
                  index: 3101,
                  "model-value": _unref(getConditionFieldTypeLabel)(newConditionOptionInput.targetFieldType),
                  options: _unref(getConditionFieldTypeOptions)(),
                  placeholder: _unref(t)('選択してください'),
                  label: _unref(t)('条件項目'),
                  "show-deselect-option": false,
                  disabled: _unref(state).isSaving,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = 
                (selectedLabel) => (newConditionOptionInput.targetFieldType = _unref(convertLabelToConditionFieldType)(selectedLabel))
              )
                }, null, 8, ["model-value", "options", "placeholder", "label", "disabled"]),
                (newConditionOptionInput.targetFieldType === 'package')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("label", _hoisted_60, _toDisplayString(_unref(t)('容量')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newConditionOptionInput.value) = $event)),
                        class: "setting-unmanaged-business-page__text-input",
                        type: "text",
                        placeholder: _unref(t)('値を入力'),
                        disabled: _unref(state).isSaving
                      }, null, 8, _hoisted_61), [
                        [_vModelText, newConditionOptionInput.value]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("label", _hoisted_63, _toDisplayString(_unref(t)('コード')), 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newConditionOptionInput.code) = $event)),
                          class: "setting-unmanaged-business-page__text-input",
                          type: "text",
                          placeholder: _unref(t)('値を入力'),
                          disabled: _unref(state).isSaving
                        }, null, 8, _hoisted_64), [
                          [_vModelText, newConditionOptionInput.code]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("label", _hoisted_66, _toDisplayString(_unref(t)('名称')), 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newConditionOptionInput.name) = $event)),
                          class: "setting-unmanaged-business-page__text-input",
                          type: "text",
                          placeholder: _unref(t)('値を入力'),
                          disabled: _unref(state).isSaving
                        }, null, 8, _hoisted_67), [
                          [_vModelText, newConditionOptionInput.name]
                        ])
                      ])
                    ], 64)),
                _createElementVNode("button", {
                  type: "button",
                  class: "setting-unmanaged-business-page__secondary-button",
                  disabled: _unref(state).isSaving,
                  onClick: addNewConditionOption
                }, [
                  _createVNode(Mdi, { icon: "add" }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('候補に追加')), 1)
                ], 8, _hoisted_68)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_69, [
            _createElementVNode("p", _hoisted_70, _toDisplayString(_unref(t)('条件に合致した場合の登録項目')), 1),
            _createElementVNode("p", _hoisted_71, _toDisplayString(_unref(t)('必須項目')), 1),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("label", _hoisted_74, _toDisplayString(_unref(t)('リードタイム')) + " *", 1),
                _createElementVNode("input", {
                  value: numericInputValues.leadTime,
                  class: "setting-unmanaged-business-page__text-input",
                  type: "number",
                  min: "1",
                  step: "1",
                  placeholder: _unref(t)('数値を入力'),
                  disabled: _unref(state).isSaving,
                  onInput: onLeadTimeInput
                }, null, 40, _hoisted_75),
                _createVNode(ErrorMessage, {
                  "is-error": _unref(fieldState).leadTime.isError.value,
                  "error-message": _unref(fieldState).leadTime.errorMessage.value
                }, null, 8, ["is-error", "error-message"])
              ]),
              _createVNode(SelectInput, {
                index: 2001,
                "model-value": _unref(getRegisterUnitLabel)(_unref(state).formSetting.registerContent.leadTimeUnit),
                options: _unref(getRegisterUnitOptions)(),
                placeholder: _unref(t)('選択してください'),
                label: `${_unref(t)('リードタイム単位')} *`,
                "show-deselect-option": false,
                disabled: _unref(state).isSaving,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = (selectedLabel) => _unref(setFormLeadTimeUnit)(_unref(convertLabelToRegisterUnit)(selectedLabel)))
              }, null, 8, ["model-value", "options", "placeholder", "label", "disabled"]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("label", _hoisted_77, _toDisplayString(_unref(t)('標準在庫指数min')) + " *", 1),
                _createElementVNode("input", {
                  value: numericInputValues.stdInventoryIndicesMin,
                  class: "setting-unmanaged-business-page__text-input",
                  type: "number",
                  min: "0.01",
                  step: "0.01",
                  placeholder: _unref(t)('数値を入力'),
                  disabled: _unref(state).isSaving,
                  onInput: onStdInventoryIndicesMinInput
                }, null, 40, _hoisted_78),
                _createVNode(ErrorMessage, {
                  "is-error": _unref(fieldState).stdInventoryIndicesMin.isError.value,
                  "error-message": _unref(fieldState).stdInventoryIndicesMin.errorMessage.value
                }, null, 8, ["is-error", "error-message"])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("label", _hoisted_80, _toDisplayString(_unref(t)('標準在庫指数max')) + " *", 1),
                _createElementVNode("input", {
                  value: numericInputValues.stdInventoryIndicesMax,
                  class: "setting-unmanaged-business-page__text-input",
                  type: "number",
                  min: "0.01",
                  step: "0.01",
                  placeholder: _unref(t)('数値を入力'),
                  disabled: _unref(state).isSaving,
                  onInput: onStdInventoryIndicesMaxInput
                }, null, 40, _hoisted_81),
                _createVNode(ErrorMessage, {
                  "is-error": _unref(fieldState).stdInventoryIndicesMax.isError.value,
                  "error-message": _unref(fieldState).stdInventoryIndicesMax.errorMessage.value
                }, null, 8, ["is-error", "error-message"])
              ]),
              _createVNode(SelectInput, {
                index: 2002,
                "model-value": _unref(getRegisterUnitLabel)(_unref(state).formSetting.registerContent.stdInventoryIndicesUnit),
                options: _unref(getRegisterUnitOptions)(),
                placeholder: _unref(t)('選択してください'),
                label: `${_unref(t)('標準在庫指数単位')} *`,
                "show-deselect-option": false,
                disabled: _unref(state).isSaving,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = (selectedLabel) => _unref(setFormStdInventoryIndicesUnit)(_unref(convertLabelToRegisterUnit)(selectedLabel)))
              }, null, 8, ["model-value", "options", "placeholder", "label", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("p", _hoisted_83, _toDisplayString(_unref(t)('任意項目')), 1),
              _createElementVNode("button", {
                type: "button",
                class: "setting-unmanaged-business-page__subtle-button",
                disabled: _unref(state).isSaving || !canAddOptionalItem(),
                onClick: addOptionalItem
              }, [
                _createVNode(Mdi, { icon: "add" }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('項目を追加')), 1)
              ], 8, _hoisted_84)
            ]),
            (_unref(state).formSetting.registerContent.optionalItems.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_unref(t)('任意項目を追加できます')), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).formSetting.registerContent.optionalItems, (optionalItem, optionalItemIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `optional-item-${optionalItemIndex}`,
                class: "setting-unmanaged-business-page__optional-row"
              }, [
                _createVNode(SelectInput, {
                  index: getFormSelectInputIndex(130 + optionalItemIndex, 1),
                  "model-value": _unref(getFieldLabel)(optionalItem.targetField),
                  options: getOptionalFieldSelectOptions(optionalItemIndex),
                  placeholder: _unref(t)('選択してください'),
                  label: _unref(t)('項目'),
                  "show-deselect-option": false,
                  disabled: _unref(state).isSaving,
                  "onUpdate:modelValue": (selectedLabel) => updateOptionalItemField(optionalItemIndex, selectedLabel)
                }, null, 8, ["index", "model-value", "options", "placeholder", "label", "disabled", "onUpdate:modelValue"]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("label", _hoisted_87, _toDisplayString(_unref(t)('値')), 1),
                  _createVNode(SuggestInput, {
                    "model-value": optionalItem.targetValue,
                    options: _unref(getOptionalItemOptions)(optionalItem.targetField, optionalItem.targetValue),
                    placeholder: _unref(t)('値を入力'),
                    disabled: _unref(state).isSaving,
                    "onUpdate:modelValue": (targetValue) => onOptionalItemTargetValueUpdate(optionalItemIndex, targetValue)
                  }, null, 8, ["model-value", "options", "placeholder", "disabled", "onUpdate:modelValue"])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "setting-unmanaged-business-page__danger-button",
                  disabled: _unref(state).isSaving,
                  onClick: ($event: any) => (removeOptionalItem(optionalItemIndex))
                }, [
                  _createVNode(Mdi, { icon: "delete_outline" }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('削除')), 1)
                ], 8, _hoisted_88)
              ]))
            }), 128)),
            _createVNode(ErrorMessage, {
              "is-error": _unref(fieldState).optionalItems.isError.value,
              "error-message": _unref(fieldState).optionalItems.errorMessage.value
            }, null, 8, ["is-error", "error-message"])
          ]),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("button", {
              type: "button",
              class: "setting-unmanaged-business-page__cancel-button",
              disabled: _unref(state).isSaving,
              onClick: backToList
            }, _toDisplayString(_unref(t)('キャンセル')), 9, _hoisted_90),
            _createElementVNode("button", {
              type: "button",
              class: "setting-unmanaged-business-page__primary-button",
              disabled: _unref(state).isSaving,
              onClick: saveFormSetting
            }, _toDisplayString(_unref(state).mode === 'create' ? _unref(t)('追加') : _unref(t)('保存')), 9, _hoisted_91)
          ])
        ]))
  ]))
}
}

})